import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import FeedContent from '../FeedContent'
import styles from './styles.module.scss'

function FeedPopup({
  feeds,
  feedIndex,
  closeModal,
  type,
  showImageModal,
  handleShowDeleteMessagePopup,
  users,
  deleteReactionFromMessage,
  addReactionToMessage,
  entity,
  isGroupOrganizer,
  showUserModal,
  showSendMessageModal,
  showFlagModal,
  totalUsers,
  isMobile,
  isTablet,
  isNative,
  isDesktop,
  level,
  feedIdToScroll,
  draftMessage,
  isMember,
  isFlagModalOpen,
  isDeleteMessagePopupOpen,
  replyOrCommentSent,
  setReplyOrCommentSent,
  feedIdToExpand,
  isFocusSetRef,
  isModalAlreadyOpenRef
}) {
  const navContainer = useRef()
  const { t } = useTranslation()
  const [currentFeed, setCurrentFeed] = useState(feeds[feedIndex])
  const [currentFeedIndex, setCurrentFeedIndex] = useState(feedIndex)
  const [touchStart, setTouchStart] = React.useState(0)
  const [touchEnd, setTouchEnd] = React.useState(0)
  const [isSwipe, setIsSwipe] = useState(false)

  useEffect(() => {
    if (navContainer) {
      navContainer.current.focus()
    }
  }, [])

  useEffect(() => {
    setCurrentFeedIndex(feedIndex)
    setCurrentFeed(feeds[feedIndex])
  }, [feedIndex])

  const movePrevious = () => {
    if (currentFeedIndex > 0) {
      setCurrentFeed(feeds[currentFeedIndex - 1])
      setCurrentFeedIndex(currentFeedIndex - 1)
      navContainer?.current?.focus()
    }
  }
  const moveNext = () => {
    if (currentFeedIndex < feeds.length - 1) {
      setCurrentFeed(feeds[currentFeedIndex + 1])
      setCurrentFeedIndex(currentFeedIndex + 1)
      navContainer?.current?.focus()
    }
  }

  const isTriggeredByInnerCarousel = (e) => {
    if (
      !e.target.className.includes('rec-carousel-item') &&
      !e.target.className.includes('rec-item-wrapper') &&
      !e.target.className.includes('commentImage') &&
      !e.target.className.includes('carouselImage') &&
      !e.target.className.includes('blurredImage') &&
      !e.target.className.includes('image')
    ) {
      return true
    }
    return false
  }

  function handleTouchStart(e) {
    //When feed contain image carousel and if you swipe on image carousel, it also swipes feed. To prevent that,
    //we are making the below check
    //https://app.asana.com/0/1140988629330369/1204904091743823
    if (isTriggeredByInnerCarousel(e)) {
      setTouchStart(e.targetTouches[0].clientX)
    }
  }

  function handleTouchMove(e) {
    if (isTriggeredByInnerCarousel(e)) {
      setIsSwipe(true)
      setTouchEnd(e.targetTouches[0].clientX)
    }
  }

  function handleTouchEnd() {
    if (isSwipe) {
      if (touchStart - touchEnd > 150) {
        // do your stuff here for right swipe
        moveNext()
      }
      if (touchStart - touchEnd < -150) {
        // do your stuff here for left swipe
        movePrevious()
      }
      setIsSwipe(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'ArrowRight') {
      moveNext()
    } else if (e.shiftKey && e.key === 'ArrowLeft') {
      movePrevious()
    }
  }

  const feedContent = (
    <FeedContent
      key={currentFeed.id}
      type={type}
      feed={feeds[currentFeedIndex]}
      feedIndex={currentFeedIndex}
      showImageModal={showImageModal}
      handleShowDeleteMessagePopup={handleShowDeleteMessagePopup}
      users={users}
      user={users && users.length > 0 ? users.find((u) => u.id === currentFeed.id_user) : null}
      showReplyButton={false}
      deleteReactionFromMessage={deleteReactionFromMessage}
      addReactionToMessage={addReactionToMessage}
      isFeedComments={false}
      showUserModal={showUserModal}
      isGroupOrganizer={isGroupOrganizer}
      entity={entity}
      totalUsers={totalUsers}
      showSendMessageModal={showSendMessageModal}
      showFlagModal={showFlagModal}
      isModal={true}
      isParentFeed={true}
      level={level}
      feedIdToExpand={feedIdToExpand}
      feedIdToScroll={feedIdToScroll}
      draftMessage={draftMessage}
      isMember={isMember}
      isFlagModalOpen={isFlagModalOpen}
      isDeleteMessagePopupOpen={isDeleteMessagePopupOpen}
      replyOrCommentSent={replyOrCommentSent}
      setReplyOrCommentSent={setReplyOrCommentSent}
      isFocusSetRef={isFocusSetRef}
      isModalAlreadyOpenRef={isModalAlreadyOpenRef}
    />
  )

  return (
    <div
      tabIndex='-1'
      className={`${styles.mainContainer} ${isNative && isDesktop && styles.nativeMainContainer}`}
      ref={navContainer}
      onTouchStart={(e) => handleTouchStart(e)}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={(e) => handleTouchEnd()}
      onKeyDown={(e) => {
        handleKeyDown(e)
      }}>
      {isMobile || isTablet ? (
        <div className={styles.mobileContainer}>
          <div className={styles.header}>
            <div className={styles.navigationContainer}>
              <div
                role='button'
                className={`${styles.navigation}  ${currentFeedIndex === 0 && styles.navigationDisabled}`}
                disabled={currentFeedIndex === 0}
                onClick={movePrevious}>
                <Icon name='arrow-left24' />
              </div>
              <span className={styles.showMorePosts}>{t('mixrHome.feeds.showMorePosts')}</span>
              <div
                role='button'
                className={`${styles.navigation} ${currentFeedIndex === feeds.length - 1 && styles.navigationDisabled}`}
                onClick={moveNext}
                disabled={currentFeedIndex === feeds.length - 1}>
                <Icon name='arrow-right' />
              </div>
            </div>
            <div role='button' className={styles.close} onClick={closeModal}>
              <Icon name='close24' />
            </div>
          </div>
          <div className={`${styles.content} ${isNative && styles.isNative}`}> {feedContent}</div>
        </div>
      ) : (
        <React.Fragment>
          <div role='button' className={`${styles.navigationButton} ${styles.closeButton} `} onClick={closeModal}>
            <Icon name='close24' styleModifier={styles.navigationIcon} />
          </div>
          <div
            role='button'
            className={`${styles.navigationButton} ${styles.leftNavigationButton} ${
              currentFeedIndex === 0 && styles.navigationButtonDisabled
            }`}
            disabled={currentFeedIndex === 0}
            onClick={movePrevious}>
            <Icon name='chevron-left' styleModifier={styles.navigationIcon} />
          </div>
          <div className={`${styles.mainWithActions} `}>{feedContent}</div>
          <div
            role='button'
            className={`${styles.navigationButton} ${styles.rightNavigationButton} ${
              currentFeedIndex === feeds.length - 1 && styles.navigationButtonDisabled
            }`}
            onClick={moveNext}
            disabled={currentFeedIndex === feeds.length - 1}>
            <Icon name='chevron-right' styleModifier={styles.navigationIcon} />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default FeedPopup
